export default __webpack_public_path__ + "static/media/50.3f6c8b80.gif";